import React, { useContext, useMemo } from 'react';
import { ModalHistoryContext } from '../History/History.js';

/**
 * Modal Route.
 */ const ModalRoute = ({ path, content })=>{
    const history = useContext(ModalHistoryContext);
    // Display route when a path matches the current location
    return useMemo(()=>{
        // Query params as props to the route
        const props = !history.route ? history.prevRoute?.query : history.route?.query;
        const isVisible = // Check against the last location to preserve modal content visible
        // until the modal is fully closed.
        !history.route?.pathname && path === history.prevRoute?.pathname || // else, match current location
        path === history.route?.pathname;
        return isVisible ? /*#__PURE__*/ React.cloneElement(content, props) : null;
    }, [
        path,
        history.route,
        history.prevRoute,
        content
    ]);
};

export { ModalRoute };
//# sourceMappingURL=Route.js.map
